var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsWordiginsBrandBrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 252 252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a86b18;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252,109.312c-4.163.833-29.7,3.608-49.4.833L192.608,157.6a11.506,11.506,0,0,1-1.11,3.33,257.884,257.884,0,0,1-24.978,21.093c4.44,1.11,8.6,2.22,13.876,3.053,26.921,4.163,43.851,4.163,61.335-.556l-18.039-38.577Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.855,158.158l-4.718,19.982a199.739,199.739,0,0,0,21.647-17.762C178.176,159.823,172.07,158.99,164.855,158.158Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.282,157.325,47.736,110.977c-19.428,2.5-43.851,0-47.736-1.11L28.308,146.5,9.991,185.079c17.485,4.44,34.692,4.718,61.335.555A131.916,131.916,0,0,0,85.2,182.581c-11.657-8.326-24.146-20.538-24.978-21.093C60.225,160.933,58.282,158.435,58.282,157.325Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.828,160.1A199.431,199.431,0,0,0,91.586,178.7l-5-20.815C79.1,158.713,72.714,159.545,68.828,160.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.965,153.162c6.383.833,14.154,1.388,20.537,3.053.278-.277.555-.555.833-.555,5.55-26.088,11.1-52.176,16.652-78.542-42.74-17.484-113.789-19.15-159.3.278,6.106,26.088,11.934,52.453,18.039,78.542h.556C94.916,146.779,135.714,149.832,165.965,153.162ZM126,128.462l-21.37,10.269,3.053-23.591L91.308,97.933l23.313-4.44L126,72.678l11.379,20.815,23.313,4.44L144.317,115.14l3.053,23.591Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsWordiginsBrandBrown);
export default __webpack_public_path__ + "static/media/icons_wordigins_brand_brown.89f269aae825fae2a7718cb4e0fd5733.svg";
export { ForwardRef as ReactComponent };